<script lang="ts">
  import type { Tile } from '$types';

  export let items: Tile[] = [];
  export let title: string = '';
  export let subtitle: string = '';
  export let class_name: 'normal' | 'large' | 'logos' | 'stacked' | 'double' | 'triple' | string = 'normal';
  export let anchor_id: string = '';
</script>

<section class="section-tiles {class_name}" id={anchor_id}>
  {#if subtitle || title}
    <div class="section-tiles-title">
      {#if subtitle}
        <p class="subtitle">{subtitle}</p>
      {/if}
      {#if title}
        <h2>{@html title}</h2>
      {/if}
    </div>
  {/if}

  <div class="tiles">
    {#each items as tile}
      <div class="tile">
        {#if tile.link}
          <a href={tile.link}>
            <img src={tile.image_url} alt={tile.alt} />
          </a>
        {:else}
          <img src={tile.image_url} alt="" />
        {/if}

        <div class="content">
          {#if tile.subtitle}
            <p class="subtitle">{tile.subtitle}</p>
          {/if}

          {#if tile.title}
            <h3>{tile.title}</h3>
          {/if}

          {#if tile.description}
            <p>{@html tile.description}</p>
          {/if}

          {#if tile.qr_code}
            <div class="qr-code">
              <span>{tile.qr_code.label}</span>
              <img src={tile.qr_code.image_url} alt="" />
            </div>
          {/if}

          {#if tile.button}
            <a href={tile.button.link} role="button" class={tile.button.highlight ? 'highlight' : 'base'} target={tile.button.target || '_self'}>
              {tile.button.text}
            </a>
          {/if}

          {#if tile.sublink}
            <span class="sublink">
              <a href={tile.sublink.link}>
                {tile.sublink.text}
                {#if tile.sublink.icon}
                  <img class="sublink-icon" src={tile.sublink.icon} alt="" />
                {/if}
              </a>
            </span>
          {/if}
        </div>
      </div>
    {/each}
  </div>
</section>
